'use strict';

var core = require('core/wishlist/wishlist');

core.baseFiles.wishlistToggleProduct = require('./components/toggleProduct');

module.exports = core;
